<template>
    <div class="booking-service-form">

        <p class="h2 card-title">{{$t( 'common.dear_guest' )}}</p>

        <i18n v-if="singleDateSelection" path="bookingService.supporting_text.singledate.text"
              tag="p" class="card-text">
            <span slot="singledate.duration">{{productVariant.duration}}</span>
            <span slot="singledate.persons">{{productVariant.persons}}</span>
            <span slot="singledate.roomtype">{{productVariant.roomType}}</span>
            <span slot="singledate.catering">{{productVariant.catering}}</span>
            <span slot="singledate.additional_feature">{{productVariant.additionalFeature}}</span>
            <span slot="singledate.hotelname">{{activationData.arrangement.hotelname}}</span>
        </i18n>

        <i18n v-else-if="isHotelContactDataPresent" path="bookingService.supporting_text.multidate.text" tag="p" class="card-text">
            <span slot="multidate.duration">{{productVariant.duration}}</span>
            <span slot="multidate.persons">{{productVariant.persons}}</span>
            <span slot="multidate.roomtype">{{productVariant.roomType}}</span>
            <span slot="multidate.catering">{{productVariant.catering}}</span>
            <span slot="multidate.additional_feature">{{productVariant.additionalFeature}}</span>
            <span slot="multidate.hotelname">{{activationData.arrangement.hotelname}}</span>

            <a slot="multidate.action.option_01" :href="modes.internal.hash"
               @click="toggleReservationVariant( $event )">
                {{$t( 'bookingService.action.link_select_reservation_option_01.text' )}}
            </a>
            <a slot="multidate.action.option_02" :href="modes.external.hash"
               @click="toggleReservationVariant( $event )">
                {{$t( 'bookingService.action.link_select_reservation_option_02.text' )}}
            </a>
        </i18n>

        <i18n v-else path="bookingService.supporting_text.multidate_online.text" tag="p" class="card-text">
            <span slot="multidate.duration">{{productVariant.duration}}</span>
            <span slot="multidate.persons">{{productVariant.persons}}</span>
            <span slot="multidate.roomtype">{{productVariant.roomType}}</span>
            <span slot="multidate.catering">{{productVariant.catering}}</span>
            <span slot="multidate.additional_feature">{{productVariant.additionalFeature}}</span>
            <span slot="multidate.hotelname">{{activationData.arrangement.hotelname}}</span>
            <span slot="multidate.action.option_01">
                    {{$t( 'bookingService.action.link_select_reservation_option_01.text' )}}
                </span>
        </i18n>

        <BookingServiceReservationForm v-bind="{reservationMode}"
                                       v-on:success="$emit('success')"/>

      <i18n path="bookingService.supporting_text.customer_support.text" tag="p"
            class="card-text">
        <CustomerServiceEmail/>
        <CustomerServicePhone/>
      </i18n>
      <p class="card-text text-secondary">
        {{$t('bookingService.supporting_text.covid')}}
      </p>
    </div>
</template>

<script>
    import ErrorMessages from './ErrorMessages';
    import BookingServiceReservationForm from './BookingServiceReservationForm';
    import bookingModes from '@/models/bookingModes';
    import CustomerServiceEmail from './CustomerServiceEmail'
    import CustomerServicePhone from './CustomerServicePhone'
    import { mapState, mapGetters } from 'vuex';

    export default {
        name: 'BookingServiceForm',
        components: {
            ErrorMessages,
            BookingServiceReservationForm,
            CustomerServiceEmail,
            CustomerServicePhone
        },
        data() {
            return {
                reservationMode: bookingModes.animodBooking,
                modes: {
                    internal: {
                        mode: bookingModes.animodBooking,
                        hash: '#reservation-option01'
                    },
                    external: {
                        mode: bookingModes.hotelBooking,
                        hash: '#reservation-option02'
                    }
                }
            };
        },
        computed: {
            ...mapState([ 'voucher', 'activationData' ]),
            ...mapGetters([ 'singleDateSelection' ]),
            productVariant() {
                return this.activationData.arrangement.productVariant || {};
            },
            showHotelContactData() {
                return !this.singleDateSelection && this.activationData.hotelContactData;
            },
            isHotelContactDataPresent() {
                return this.activationData.hotelContactData
                    && (this.activationData.hotelContactData.phone || this.activationData.hotelContactData.email);
            }
        },
        methods: {
            toggleReservationVariant( event ) {
                const hash = event.currentTarget.hash;
                if (hash === this.modes.internal.hash) {
                    this.reservationMode = this.modes.internal.mode;
                }
                else if (hash === this.modes.external.hash) {
                    this.reservationMode = this.modes.external.mode;
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @use "@/styles/_variables";

    .avp-card-section {
        margin-bottom: 1.25rem;

        .form-control {
            margin-bottom: 0.625rem;
        }
    }
</style>
